import { Link } from 'react-router-dom';
import { FaFacebookF } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-100 py-8 border-t border-gray-300 text-gray-600">
      <div className="container mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8">

        <div>
        <Link to="/" style={{ textDecoration: 'none', color: '#854d0e' }}>
         <h2 className="text-xl font-bold">Fashion</h2>
         </Link>
          <p className="m t-2 text-sm text-gray-800">The one stop destiantion for the all the trending clothes and accessories.</p>
          <div className="flex space-x-4 mt-4">
            {/*<img src="chttps://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/1200px-Stripe_Logo%2C_revised_2016.svg.pnglient/src/images/stripe.pnghttps://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcREFG_shbxV7ib4ezJAaos2DcQ95T6j_AC8ng&s" alt="Stripe" 
            className=" h-6" />*/}
            <img src="https://cdn.iconscout.com/icon/free/png-256/free-razorpay-logo-icon-download-in-svg-png-gif-file-formats--payment-gateway-brand-logos-icons-1399875.png?f=webp" alt="Razorpay" className="w-16 h-16" />
          </div>
          <div className="flex space-x-4 mt-4">
             <FcGoogle className="text-xl mr-2" />
             <FaFacebookF className="text-blue-600 text-xl mr-2" />
             <FaInstagram className="text-xl mr-2" /> 
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold">Department</h3>
          <ul className="mt-2 space-y-1 text-sm">
            <li><a href="#" className="hover:text-gray-900">Fashion</a></li>
            <li><a href="#" className="hover:text-gray-900">Womens Clothing</a></li>
            <li><a href="#" className="hover:text-gray-900">Mens Clothing</a></li>
            <li><a href="#" className="hover:text-gray-900">Gadgets</a></li>
            <li><a href="#" className="hover:text-gray-900">Accessiores</a></li>
          </ul>
        </div>

        <div>
        <h3 className="text-lg font-semibold">AboutUs</h3>
          <Link to="/about" className="hover:underline">
          About
        </Link>
          <ul className="mt-2 space-y-1 text-sm">
            <li><a href="#" className="hover:text-gray-900">Careers</a></li>
            <li><a href="#" className="hover:text-gray-900">News & Blog</a></li>
            <li><a href="#" className="hover:text-gray-900">Shop by Location</a></li>
            <li><a href="#" className="hover:text-gray-900">Affiliate & Partners</a></li>
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold">Help</h3>
          <Link to="/help-center" className="hover:underline">
          Help Center
        </Link>
          <ul className="mt-2 space-y-1 text-sm">
            <li><a href="#" className="hover:text-gray-900">Returns</a></li>
            <li><a href="#" className="hover:text-gray-900">Track Orders</a></li>
            <Link to="/contact" className="hover:text-gray-900">Contact</Link>
            <li><a href="#" className="hover:text-gray-900">Security & Fraud</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t mt-8 py-4 text-center text-sm">
        <p>&copy; {new Date().getFullYear()} All Rights Reserved | Designed by Fashion</p>
      </div>
    </footer>
  );
};

export default Footer;
